import { initReactI18next } from 'react-i18next';
import i18n, { InitOptions } from 'i18next';
import deepmerge from 'deepmerge';
import COMMON_EN_TRANSLATION from './en/common.json';
import COMMON_ES_TRANSLATION from './es/common.json';
import COMMON_FR_TRANSLATION from './fr/common.json';
import COMMON_PT_TRANSLATION from './pt/common.json';
import TENANT_US_TRANSLATION from './en/us.json';
import TENANT_AR_TRANSLATION from './es/ar.json';
import TENANT_CL_TRANSLATION from './es/cl.json';
import TENANT_CO_TRANSLATION from './es/co.json';
import TENANT_ES_TRANSLATION from './es/es.json';
import TENANT_MX_TRANSLATION from './es/mx.json';
import TENANT_PE_TRANSLATION from './es/pe.json';
import TENANT_UY_TRANSLATION from './es/uy.json';
import TENANT_BR_TRANSLATION from './pt/br.json';
import TENANT_PT_UY_TRANSLATION from './pt/uy.json';
import TENANT_EN_CA_TRANSLATION from './en/ca.json';
import TENANT_FR_CA_TRANSLATION from './fr/ca.json';

export const DefaultLanguage = 'en';
export const Languages = ['en', 'es', 'pt', 'fr'];

const options: InitOptions = {
  resources: {
    'en': {
      translation: deepmerge(COMMON_EN_TRANSLATION, TENANT_US_TRANSLATION),
    },
    'es': {
      translation: deepmerge(COMMON_ES_TRANSLATION, TENANT_ES_TRANSLATION),
    },
    'es-AR': {
      translation: deepmerge(COMMON_ES_TRANSLATION, TENANT_AR_TRANSLATION),
    },
    'es-CL': {
      translation: deepmerge(COMMON_ES_TRANSLATION, TENANT_CL_TRANSLATION),
    },
    'es-CO': {
      translation: deepmerge(COMMON_ES_TRANSLATION, TENANT_CO_TRANSLATION),
    },
    'es-MX': {
      translation: deepmerge(COMMON_ES_TRANSLATION, TENANT_MX_TRANSLATION),
    },
    'es-PE': {
      translation: deepmerge(COMMON_ES_TRANSLATION, TENANT_PE_TRANSLATION),
    },
    'es-UY': {
      translation: deepmerge(COMMON_ES_TRANSLATION, TENANT_UY_TRANSLATION),
    },
    'pt': {
      translation: deepmerge(COMMON_PT_TRANSLATION, TENANT_BR_TRANSLATION),
    },
    'pt-UY': {
      translation: deepmerge(COMMON_PT_TRANSLATION, TENANT_PT_UY_TRANSLATION),
    },
    'en-CA': {
      translation: deepmerge(COMMON_EN_TRANSLATION, TENANT_EN_CA_TRANSLATION),
    },
    'fr-CA': {
      translation: deepmerge(COMMON_FR_TRANSLATION, TENANT_FR_CA_TRANSLATION),
    },
  },
  lng: DefaultLanguage,
  fallbackLng: DefaultLanguage,
  supportedLngs: [...Languages, 'es-AR', 'es-CL', 'es-CO', 'es-MX', 'es-PE', 'es-UY', 'pt-UY', 'en-CA', 'fr-CA'],
};

export const initI18n = () => {
  i18n.use(initReactI18next).init(options);
};

export const setLanguage = async (lang: string): Promise<void> => {
  await i18n.changeLanguage(lang);
};

export const getLanguageCode = (): string => {
  return i18n.language?.substring(0, 2) ?? DefaultLanguage;
};
